import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DinominationsModalPage } from './dinominations-modal.page';

const routes: Routes = [
  {
    path: '',
    component: DinominationsModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DinominationsModalPageRoutingModule {}
